export function initTabs($) {
  function initTabs($container) {
    function switchTab(tabID) {
      // Tabs
      $container.find(".tab-link").removeClass("active");
      $container.find('.tab-link[data-tab="' + tabID + '"]').addClass("active");
  
      // Dots / Markets progress navigation
      $container.find(".dot, .markets-progress_button")
        .removeClass("active")
        .attr("aria-selected", "false");

      const $activeIndicator = $container.find(
        '.dot[data-tab="' + tabID + '"], .markets-progress_button[data-tab="' + tabID + '"]'
      );
      $activeIndicator.addClass("active").attr("aria-selected", "true");

      // Restart the active Markets progress animation from zero.
      const activeFill = $activeIndicator.find(".markets-progress_fill").get(0);
      if (activeFill) {
        activeFill.style.animation = "none";
        // Restart after a rendered frame without forcing synchronous layout.
        requestAnimationFrame(() => requestAnimationFrame(() => {
          activeFill.style.animation = "";
        }));
      }
  
      // Content
      $container.find(".tab-content").removeClass("active");
      $container.find("#" + tabID).addClass("active");
  
      // Stop videos in inactive tabs only
      $container.find(".tab-content:not(#" + tabID + ") video").each(function () {
        this.pause();
        this.currentTime = 0;
      });
  
      $container.find(".tab-content:not(#" + tabID + ") .video-wrapper").removeClass("is-playing");
  
      const $prices = $container.find(".pricing-col .pricing-main .pricing-price");
      if ($prices.length) $prices.matchHeight();
    }
  
    // Tab clicks
    $container.find(".tab-link, .dot, .markets-progress_button").on("click", function () {
      switchTab($(this).data("tab"));
    });

    // The CSS fill animation is the timer, so visual progress and slide
    // advancement always remain synchronized.
    $container.on("animationend", ".markets-progress_fill", function (event) {
      if (event.originalEvent?.animationName !== "markets-progress-fill") return;

      const $buttons = $container.find(".markets-progress_button");
      const currentIndex = $buttons.index($(this).closest(".markets-progress_button"));
      const nextIndex = (currentIndex + 1) % $buttons.length;
      const nextTab = $buttons.eq(nextIndex).data("tab");

      if (nextTab) switchTab(nextTab);
    });
  
    // Unified play/pause
    function toggleVideo($wrapper) {
      const video = $wrapper.find("video").get(0);
      if (!video) return;
  
      if (video.paused) {
        video.play();
        $wrapper.addClass("is-playing");
      } else {
        video.pause();
        $wrapper.removeClass("is-playing");
      }
    }
  
    $container.on("click", ".video-play-btn", function (e) {
      e.stopPropagation();
      toggleVideo($(this).closest(".video-wrapper"));
    });
  
    $container.on("click", "video", function () {
      toggleVideo($(this).closest(".video-wrapper"));
    });
  }
  
  // Init all blocks safely
  $(".markets-container, .product-feature-container, .pricing-container").each(function () {
    initTabs($(this));
  });
  
  function initFeaturedProductsTabs($container) {
    function switchTab(tabID) {
      // Tabs
      $container.find(".tab-link").removeClass("active");
      $container.find('.tab-link[data-tab="' + tabID + '"]').addClass("active");
  
      // Content
      $container.find(".tab-content").removeClass("active");
      $container.find("#" + tabID).addClass("active");
    }
  
    // Hover activates tab (NO preventDefault)
    $container.on("mouseenter", ".tab-link", function () {
      const targetTab = $(this).data("tab");
      switchTab(targetTab);
    });
  }
  
  // Init
  $(".featured-products_outer").each(function () {
    initFeaturedProductsTabs($(this));
  });
}
